module.exports = __webpack_public_path__ + "media/images/subheader-format-one-69a47db80c0bde3f55cd9953f66174c1.png";